{
  "title": "Temporal Shunt",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "5th-level transmutation (dunamancy:chronurgy)",
  "level": 5,
  "castingTime": "1 reaction, taken when a creature you see makes an attack roll or starts to cast a spell",
  "range": "120 feet",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "You target the triggering creature, which must succeed on a Wisdom saving throw or vanish, being thrown to another point in time and causing the attack to miss or the spell to be wasted. At the start of its next turn, the target reappears where it was or in the closest unoccupied space. The target doesn't remember you casting the spell or being affected by it.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, you can target one additional creature for each slot level above 5th. All targets must be within 30 feet of each other."
  ],
  "spellLists": ["wizard"]
}
